export function cleanParams<T>(params?: T) {
  if (!params) return undefined;
  return Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v !== ''),
  ) as Partial<T>;
}
